import React, { useEffect, useRef, useState } from 'react'
import Button from '../Button/Button'
import { CopyButtonProps } from './CopyButton.types'
import Tooltip from '../Tooltip/Tooltip'
import merge from 'lodash/merge'
const CopyButton: React.FC<CopyButtonProps> = ({
    buttonProps = {},
    copyContent,
    copyLabel = 'Copy',
    copiedLabel = 'Copied',
    showContentAsTooltip = false,
}) => {
    const [isCopied, setIsCopied] = useState(false)
    const [showTooltip, setShowTooltip] = useState(false)

    const ref = useRef()
    useEffect(() => {
        if (isCopied) {
            setTimeout(() => setIsCopied(false), 1000)
        }
    }, [isCopied])

    const handleClick = () => {
        setIsCopied(true)
        navigator.clipboard.writeText(copyContent)
    }

    const props = merge(
        {
            icon: 'copy',
        },
        buttonProps,
    )

    const label = buttonProps.label || 'Copy'

    return (
        <React.Fragment>
            <Button
                {...props}
                ref={ref}
                onMouseEnter={() => {
                    if (showContentAsTooltip) {
                        setShowTooltip(true)
                    }
                }}
                onMouseLeave={() => {
                    if (showTooltip) {
                        setShowTooltip(false)
                    }
                }}
                label={isCopied ? copiedLabel : label}
                onClick={handleClick}
            />
            <Tooltip show={showTooltip} anchor={ref}>
                <div style={{ opacity: 0.65, marginBottom: '10px' }}>The following will be copied: </div>
                {copyContent}
            </Tooltip>
        </React.Fragment>
    )
}

export default CopyButton
